export const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export function category(comic) {
    const status = normalize(comic.status).replace(/[-_]/g, ' ');
    const tags = (comic.genres || []).map(g => normalize(g.slug || g.name).replace(/[\s_-]/g, ''));
    if (tags.includes('oneshot') || status.replace(/[\s_-]/g, '') === 'oneshot') return 'one-shot';
    if (/^(fini|termine|complete|conclu|finished|completed)/.test(status)) return 'completed';
    if (/^(en cours|ongoing|on going|airing|in corso|publishing)/.test(status)) return 'on-going';
    return 'other';
}
export function chapterLabel(chapter) {
    if (!chapter) return '';
    if (chapter.chapter === null || chapter.chapter === undefined || chapter.chapter === '') return chapter.full_title || 'Lire';
    return 'Chapitre ' + chapter.chapter + (chapter.subchapter ? '.' + chapter.subchapter : '');
}
export function publishedTime(value, now = Date.now()) {
    const date = new Date(value);
    if (!value || !Number.isFinite(date.getTime())) return '';
    const days = Math.floor((now - date.getTime()) / 86400000);
    if (days < 0) return date.toLocaleDateString('fr-FR');
    if (days === 0) return "Aujourd’hui";
    if (days < 7) return days + ' j';
    return date.toLocaleDateString('fr-FR');
}
export function recent(chapter, now = Date.now()) {
    const age = now - new Date(chapter?.published_on).getTime();
    return Number.isFinite(age) && age >= 0 && age < 3 * 86400000;
}
export function coverFallback(event, comic) {
    const image = event.target;
    if (image.dataset.fallback) { image.style.opacity = '0'; return; }
    image.dataset.fallback = '1'; image.src = comic.thumbnail_small || comic.thumbnail || '';
}
